import type { WalletMonitoringToken } from '@shared/api/contracts';

export const WALLET_TOKEN_ORDER: WalletMonitoringToken[] = [
  'USDT',
  'BTC',
  'ETH',
  'BNB',
  'TRX',
  'LTC',
];
